import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSubscription } from "../providers/SubscriptionProvider";
import { useAuth } from "../contexts/AuthContext";
import { StripeService } from "../services/stripeService";

const SubscriptionChangeNotice: React.FC = () => {
  const { subscription, refreshSubscription } = useSubscription();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  // Nothing to show
  if (
    !subscription ||
    !subscription.subscriptionChangeMessage ||
    subscription.subscriptionChangeRead === true ||
    dismissed
  ) {
    return null;
  }

  const handleDontShowAgain = async () => {
    if (!currentUser?.uid) return;
    try {
      setLoading(true);

      // call your backend helper
      await StripeService.markSubscriptionMessageRead();

      await refreshSubscription();
      setDismissed(true);
    } catch (err) {
      console.error("Failed to mark subscription message read", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-xl">
      <div className="bg-base-100 border border-base-200 shadow-lg rounded-xl p-4 flex flex-col gap-3">

        <p className="text-sm text-base-content">
          {subscription.subscriptionChangeMessage}
        </p>

        <div className="flex justify-end gap-2">
          <button
            className="px-3 py-1.5 text-sm rounded-md bg-base-200 hover:bg-base-300"
            onClick={() => setDismissed(true)}
          >
            Close
          </button>

          <button
            className="px-3 py-1.5 text-sm rounded-md bg-base-200 hover:bg-base-300"
            onClick={() => navigate("/settings/subscription")}
          >
            Manage Subscription
          </button>

          <button
            className="px-3 py-1.5 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            disabled={loading}
            onClick={handleDontShowAgain}
          >
            {loading ? "Saving..." : "Don't show again"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default SubscriptionChangeNotice;